// extracted by mini-css-extract-plugin
module.exports = {"footerBasic":"Footer_footerBasic__2JtvV","social":"Footer_social__2M4qp","copyright":"Footer_copyright__1ZVtY"};